export const ar = {
  metaTitle: "الاشتراك و الفوترة - OrderHub",
  metaDescription: "إدارة خطتك ومراقبة الاستخدام وعرض الفواتير.",
  title: "الاشتراك و الفوترة",
  breadcrumb: "الاشتراك",
  subtitle: "إدارة خطتك ومراقبة الاستخدام وعرض الفواتير",
  syncButton: "مزامنة",
  syncSyncing: "جارٍ المزامنة...",
  syncSynced: "تمت المزامنة",
  syncRetry: "إعادة المحاولة",
  lastSynced: "آخر مزامنة: {{time}}",
  planUpgradedToast: "تمت ترقية الخطة بنجاح! دعو فريقك للبدء.",
  syncSuccessToast: "تمت مزامنة الاشتراك بنجاح",
  syncFailedToast: "فشل مزامنة الاشتراك",
  syncErrorNoStore: "لا يوجد متجر متصل. اربط متجرًا لمزامنة الفوترة.",
  syncErrorNoSubscription: "لم يتم العثور على اشتراك نشط في Shopify.",
  syncErrorGeneric: "فشلت المزامنة. يرجى المحاولة مرة أخرى.",
  syncErrorTokenExpired: "انتهت صلاحية رمز الوصول للمتجر. يرجى إعادة ربط متجرك.",
  statCard: {
    activeUsers: "المستخدمون النشطون",
    billingPeriod: "فترة الاشتراك",
    quickActions: "إجراءات سريعة",
  },
  upgradePlan: "ترقية الخطة",
  managePlanOnShopify: "إدارة الخطة على Shopify",
  needMoreUsersContact: "تحتاج إلى أكثر من {{limit}} مستخدم؟ اتصل بنا",
  billingDetails: "تفاصيل الفواتير والمعاملات",
  billingDetailsSection: {
    connectedTitle: "اعرض فواتيرك وأدر الفوترة مباشرة في Shopify",
    connectedDescription:
      "تتم معالجة اشتراكك وسجل المدفوعات بشكل آمن من خلال Shopify.",
    disconnectedDescription:
      "اربط متجر Shopify الخاص بك لعرض الفواتير وتفاصيل الفوترة.",
    viewInShopify: "عرض الفوترة في Shopify",
    connectStore: "توصيل المتجر",
  },
  paymentIssueBannerTitle: "تم اكتشاف مشكلة في الدفع",
  paymentIssueBannerDescription:
    "اشتراكك لديه مشكلة في الدفع. يرجى اختيار خطة أدناه لاستعادة الفوترة.",
  noStoreBannerTitle: "قم بتوصيل متجر Shopify للبدء",
  noStoreBannerDescription:
    "تتم إدارة الفوترة من خلال Shopify. قم بتوصيل متجر أولاً لاختيار خطة وتفعيل اشتراكك.",
  noStoreBannerAction: "توصيل المتجر",
  trustBadge: {
    secureBilling: "فوترة آمنة عبر Shopify",
    proratedChanges: "تغييرات متناسبة",
    syncAnytime: "مزامنة في أي وقت",
  },
  hero: {
    usersBadge: "{{count}} مستخدمين",
    usersBadgeTip: "تشمل خطتك حتى {{limit}} عضو فريق نشط",
    shopifyBillingBadge: "فوترة من خلال Shopify",
    shopifyBillingTip: "يتم إدارة اشتراكك من خلال Shopify",
    freeForever: "مجاني للأبد",
    renewsOn: "يتجدد فى {{date}}",
    free: "مجاني",
    upgradePlan: "ترقية الخطة",
    managePlan: "إدارة الخطة",
    cancelling: "جارٍ إلغاء الاشتراك",
    endsOn: " — تنتهي خطتك في {{date}}",
    keepMyPlan: "الاحتفاظ بخطتي",
    seatsUsed: "مقاعد مستخدمة",
    seatsUsedTip: "{{active}} من {{limit}} مقعد مستخدم قيد الاستخدام حاليًا",
    stores: "متجر",
    storesTip: "{{count}} متجر(ات) متصل بمساحة عملك",
    activitiesThisMonth: "مهام هذا الشهر",
    activitiesTip: "{{count}} مهام طلبات مسجلة هذا الشهر",
    daysLeft: "أيام متبقية",
    connectStoreBannerTitle: "قم بتوصيل متجر Shopify لتفعيل الفوترة",
    connectStoreBannerDescription:
      "تتم إدارة الفوترة من خلال Shopify. قم بتوصيل متجر للمتابعة.",
    connectStoreBannerAction: "توصيل المتجر",
  },
  intervalToggle: {
    monthly: "شهري",
    annual: "سنوي",
    save20: "وفّر 20%",
  },
  priceSuffix: {
    monthlyShort: "شهر",
    yearlyShort: "سنة",
  },
  usageMeter: {
    of: "من",
    activeSeatTip: "مقعد نشط #{{index}}",
    seatsUsedTip: "لقد استخدمت {{current}} من {{limit}} مقعد متاح",
    activities: "المهام",
    thisMonth: "هذا الشهر",
    stores: "المتاجر",
    connected: "متصل",
  },
  comparison: {
    title: "اختر خطتك",
    description: "ستتم إعادة توجيهك إلى Shopify لإكمال اختيار الخطة.",
    popular: "شائع",
    free: "مجاني",
    default: "افتراضي",
    select: "اختيار",
    currentPlan: "الخطة الحالية",
    featuresHeader: "الميزات",
    freePlanError: "الخطة المجانية مضمنة افتراضيًا. للترقية لأسفل، ألغِ اشتراكك الحالي من إدارة Shopify.",
    retry: "إعادة المحاولة",
    redirecting: "جارٍ إعادة التوجيه إلى Shopify...",
    secureBilling: "فوترة آمنة",
    proratedChanges: "تغييرات متناسبة",
    cancelAnytime: "إلغاء في أي وقت",
    changesNextCycle: "تنطبق التغييرات في دورة الاشتراك التالية",
  },
  downgrade: {
    successTitle: "تم تخفيض الخطة",
    successBody: "تم تغيير خطتك إلى {{planName}} فورًا.",
    overLimitTitle: "المستخدمون يتجاوزون حد الخطة",
    overLimitDescription: "أزل أعضاء الفريق قبل التخفيض إلى {{planName}}",
    actionRequired: "إجراء مطلوب",
    removeUsersBefore: "أزل {{count}} مستخدم(ين) قبل التخفيض",
    currentCount: "الحالي: {{count}}",
    limitCount: "الحد: {{count}}",
    featuresYouWillLose: "الميزات التي ستفقدها",
    manageUsers: "إدارة المستخدمين",
    title: "تخفيض من {{planName}}",
    immediateDescription: "يسري هذا التغيير فورًا",
    immediateLabel: "تخفيض فوري",
    keepPlan: "الاحتفاظ بـ {{planName}}",
    redirecting: "جارٍ إعادة التوجيه إلى Shopify...",
    downgradeNow: "تخفيض الآن",
    teamCapacity: "سعة الفريق: {{from}} ← {{to}} عضو(ين)",
    immediateChangeBody: "ستتغير خطتك من {{planName}} إلى {{targetPlanName}} فورًا. ستفقد الوصول إلى ميزات {{planName}} فورًا.",
    managerConflictTitle: "أدوار المديرين تتجاوز ميزات الخطة",
    managerConflictDescription: "لا تشمل خطة {{planName}} إدارة الفريق",
    demoteManagersBefore: "قم بخفض رتبة {{count}} مستخدم(ين) بدور مدير إلى ممثل أو أزلهم قبل التخفيض",
    managerCount: "المديرون: {{count}}",
    managerHint: "ميزات المدير (صندوق الفريق، التقارير، العملاء) تتطلب خطة Growth أو أعلى",
  },
  tierStrip: {
    popular: "شائع",
    free: "مجاني",
    upgrade: "ترقية",
    select: "اختيار",
    currentPlan: "الخطة الحالية",
    switchToAnnual: "التحويل إلى سنوي",
    switchToMonthly: "التحويل إلى شهري",
    perMonthEquiv: "/شهر مكافئ",
    user: "مستخدم",
  },
  periodCard: {
    noActivePeriod: "لا توجد فترة نشطة",
    upgradeToActivate: "ترقية لتفعيل الاشتراك",
    daysRemaining: "أيام متبقية",
    expiringSoon: "ينتهي قريبًا",
    autoRenews: "يتجدد تلقائيًا",
    endsSoonTooltip: "تنتهي فترة الاشتراك قريبًا — ستتجدد تلقائيًا",
    autoRenewTooltip: "سيتجدد اشتراكك تلقائيًا في نهاية الفترة",
    managedVia: "مُدار عبر",
  },
  invoices: {
    totalPaid: "إجمالي المدفوع",
    invoices: "الفواتير",
    lastPayment: "آخر دفع",
    empty: "لا توجد فواتير بعد",
    emptyDescription: "ستظهر الفواتير هنا بمجرد أن يكون لديك اشتراك مدفوع نشط",
    downloadPdf: "تنزيل PDF",
    columns: {
      date: "التاريخ",
      invoice: "الفاتورة",
      amount: "المبلغ",
      status: "الحالة",
      pdf: "PDF",
    },
    status: {
      paid: "مدفوع",
      pending: "قيد الانتظار",
      failed: "فشل",
    },
  },
  pagination: {
    showing: "عرض",
    of: "من",
    invoices: "فواتير",
    rows: "صفوف",
    rowsPerPage: "صفوف لكل صفحة",
  },
  plans: {
    free: { name: "مجاني", label: "لرواد الأعمال الفرديين" },
    starter: { name: "تمهيدي", label: "للفرق الصغيرة" },
    growth: { name: "انطلاق", label: "للشركات النامية" },
    scale: { name: "توسع", label: "للعمليات المتوسعة" },
  },
  features: {
    team_members: "مستخدمون",
    order_management: "إدارة الطلبات",
    basic_analytics: "تحليلات أساسية",
    priority_support: "دعم ذو أولوية",
    team: "إدارة الفريق",
    vip_customers: "عملاء VIP",
    account_manager: "مدير حساب مخصص",
  },
} as const;
